export const MAX_RECENT_SEARCHES_STORED_IN_COOKIES = 16;
